module.exports = __webpack_public_path__ + "img/pei2.7c43fa67.png";